!function (e, t) {
  "object" == typeof exports && "undefined" != typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define(t) : (e.ReactIntlLocaleData = e.ReactIntlLocaleData || {}, e.ReactIntlLocaleData.mr = t());
}(this, function () {
  "use strict";

  return [{
    locale: "mr",
    pluralRuleFunction: function (e, t) {
      return t ? 1 == e ? "one" : 2 == e || 3 == e ? "two" : 4 == e ? "few" : "other" : e >= 0 && e <= 1 ? "one" : "other";
    },
    fields: {
      year: {
        displayName: "वर्ष",
        relative: {
          0: "हे वर्ष",
          1: "पुढील वर्ष",
          "-1": "मागील वर्ष"
        },
        relativeTime: {
          future: {
            one: "येत्या {0} वर्षामध्ये",
            other: "येत्या {0} वर्षांमध्ये"
          },
          past: {
            one: "{0} वर्षापूर्वी",
            other: "{0} वर्षांपूर्वी"
          }
        }
      },
      "year-short": {
        displayName: "वर्ष",
        relative: {
          0: "हे वर्ष",
          1: "पुढील वर्ष",
          "-1": "मागील वर्ष"
        },
        relativeTime: {
          future: {
            one: "{0} वर्षामध्ये",
            other: "{0} वर्षांमध्ये"
          },
          past: {
            one: "{0} वर्षापूर्वी",
            other: "{0} वर्षांपूर्वी"
          }
        }
      },
      month: {
        displayName: "महिना",
        relative: {
          0: "हा महिना",
          1: "पुढील महिना",
          "-1": "मागील महिना"
        },
        relativeTime: {
          future: {
            one: "येत्या {0} महिन्यामध्ये",
            other: "येत्या {0} महिन्यांमध्ये"
          },
          past: {
            one: "{0} महिन्यापूर्वी",
            other: "{0} महिन्यांपूर्वी"
          }
        }
      },
      "month-short": {
        displayName: "महिना",
        relative: {
          0: "हा महिना",
          1: "पुढील महिना",
          "-1": "मागील महिना"
        },
        relativeTime: {
          future: {
            one: "{0} महिन्यामध्ये",
            other: "{0} महिन्यामध्ये"
          },
          past: {
            one: "{0} महिन्यापूर्वी",
            other: "{0} महिन्यांपूर्वी"
          }
        }
      },
      day: {
        displayName: "दिवस",
        relative: {
          0: "आज",
          1: "उद्या",
          "-1": "काल"
        },
        relativeTime: {
          future: {
            one: "येत्या {0} दिवसामध्ये",
            other: "येत्या {0} दिवसांमध्ये"
          },
          past: {
            one: "{0} दिवसापूर्वी",
            other: "{0} दिवसांपूर्वी"
          }
        }
      },
      "day-short": {
        displayName: "दिवस",
        relative: {
          0: "आज",
          1: "उद्या",
          "-1": "काल"
        },
        relativeTime: {
          future: {
            one: "{0} दिवसामध्ये",
            other: "येत्या {0} दिवसांमध्ये"
          },
          past: {
            one: "{0} दिवसापूर्वी",
            other: "{0} दिवसांपूर्वी"
          }
        }
      },
      hour: {
        displayName: "तास",
        relative: {
          0: "तासात"
        },
        relativeTime: {
          future: {
            one: "{0} तासामध्ये",
            other: "{0} तासांमध्ये"
          },
          past: {
            one: "{0} तासापूर्वी",
            other: "{0} तासांपूर्वी"
          }
        }
      },
      "hour-short": {
        displayName: "तास",
        relative: {
          0: "तासात"
        },
        relativeTime: {
          future: {
            one: "{0} तासामध्ये",
            other: "{0} तासांमध्ये"
          },
          past: {
            one: "{0} तासापूर्वी",
            other: "{0} तासांपूर्वी"
          }
        }
      },
      minute: {
        displayName: "मिनिट",
        relative: {
          0: "या मिनिटात"
        },
        relativeTime: {
          future: {
            one: "{0} मिनिटामध्ये",
            other: "{0} मिनिटांमध्ये"
          },
          past: {
            one: "{0} मिनिटापूर्वी",
            other: "{0} मिनिटांपूर्वी"
          }
        }
      },
      "minute-short": {
        displayName: "मि.",
        relative: {
          0: "या मिनिटात"
        },
        relativeTime: {
          future: {
            one: "{0} मिनि. मध्ये",
            other: "{0} मिनि. मध्ये"
          },
          past: {
            one: "{0} मिनि. पूर्वी",
            other: "{0} मिनि. पूर्वी"
          }
        }
      },
      second: {
        displayName: "सेकंद",
        relative: {
          0: "आत्ता"
        },
        relativeTime: {
          future: {
            one: "{0} सेकंदामध्ये",
            other: "{0} सेकंदांमध्ये"
          },
          past: {
            one: "{0} सेकंदापूर्वी",
            other: "{0} सेकंदांपूर्वी"
          }
        }
      },
      "second-short": {
        displayName: "से.",
        relative: {
          0: "आत्ता"
        },
        relativeTime: {
          future: {
            one: "{0} से. मध्ये",
            other: "{0} से. मध्ये"
          },
          past: {
            one: "{0} से. पूर्वी",
            other: "{0} से. पूर्वी"
          }
        }
      }
    }
  }];
});